module.exports = __webpack_public_path__ + "img/debbie.526ed3c0.jpg";